module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-common', {
    attrs: {
      "type": "normal",
      "showAppTopLink": _vm.isSharePage,
      "showAppBotLink": _vm.isSharePage,
      "detail": _vm.data
    }
  }, [(_vm.data) ? _c('h1', {
    staticClass: "QA-subject",
    domProps: {
      "innerHTML": _vm._s(_vm.data.subject)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data) ? _c('section', {
    staticClass: "QA-area"
  }, [_c('div', {
    staticClass: "QQ-wrap"
  }, [_c('div', {
    staticClass: "QQ_header header-wrap flex flex-default flex-main-justify"
  }, [_c('div', {
    staticClass: "flex flex-cross-center"
  }, [_c('div', {
    staticClass: "avatar",
    style: ({
      backgroundImage: ("url(" + (_vm.data.avatar?_vm.data.avatar:_vm.icon) + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "info-area"
  }, [_c('div', {
    staticClass: "name ellipsis"
  }, [_vm._v(" " + _vm._s(_vm.data.nickName))]), _vm._v(" "), _c('div', {
    staticClass: "time ellipsis"
  }, [_vm._v(_vm._s(_vm.data.dateline))])])]), _vm._v(" "), _c('div', {
    class: ['like', 'flex', 'flex-cross-center',
      _vm.data.stateName == '已回复' ? 'replied' : _vm.data.stateName == '未回复' ? 'no_replied' : ''
    ]
  })]), _vm._v(" "), _c('div', {
    class: ['content', 'font-size-' + _vm.fontSizeNum],
    domProps: {
      "innerHTML": _vm._s(_vm.summaryReplace(_vm.data.content))
    }
  }), _vm._v(" "), (_vm.data.attachmentList) ? _c('ul', {
    staticClass: "media-list"
  }, _vm._l((_vm.data.attachmentList), function(item, index) {
    return _c('li', {
      key: index,
      class: item.type == 'video' ? 'icon-video' : '',
      on: {
        "click": function($event) {
          return _vm.bigImage(item.type, item.imageUrl)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.imageUrl
      }
    })])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.data.asOrgName && _vm.data.asContent) ? _c('div', {
    staticClass: "lines"
  }) : _vm._e(), _vm._v(" "), (_vm.data.asOrgName && _vm.data.asContent) ? _c('div', {
    staticClass: "QA-wrap"
  }, [_c('div', {
    staticClass: "QA-label"
  }, [_c('label', [_vm._v("- 反馈 -")])]), _vm._v(" "), _c('i', {
    staticClass: "start"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentDiv"
  }, [_c('div', [_c('div', {
    class: ['content', 'font-size-' + _vm.fontSizeNum],
    domProps: {
      "innerHTML": _vm._s(_vm.summaryReplace(_vm.data.asContent))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-wrap_as"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.data.asDateline) + " "), _c('span', {
    staticClass: "ending"
  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-footer"
  }), _vm._v(" "), _c('ul', {
    staticClass: "article-desc"
  }, [_c('li', [_vm._v("未经授权，严禁转载")]), _vm._v(" "), _c('li', [_vm._v("联系电话：028-86751128")])]), _vm._v(" "), (_vm.comments !== null && _vm.comments.length > 0) ? _c('div', {
    staticClass: "comment"
  }, [(_vm.comments.length > 0) ? _c('div', {
    staticClass: "title"
  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v("热门评论")])]) : _vm._e(), _vm._v(" "), (_vm.comments.length > 0) ? _c('div', [_c('ul', _vm._l((_vm.comments), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.addComment(item)
        }
      }
    }, [_c('header', {
      staticClass: "flex flex-cross-center flex-main-justify"
    }, [_c('div', {
      staticClass: "flex flex-cross-center"
    }, [_c('div', {
      staticClass: "avatar",
      style: ({
        backgroundImage: ("url(" + (item.userIcon?item.userIcon:_vm.icon) + ")")
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "info-area"
    }, [_c('div', {
      staticClass: "name ellipsis"
    }, [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('div', {
      staticClass: "time ellipsis"
    }, [_vm._v(_vm._s(_vm.getTime(item.date)))])])]), _vm._v(" "), _c('div', {
      staticClass: "like flex flex-cross-center",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setActiveLike(item)
        }
      }
    }, [_c('span', {
      class: [item.isLike ? 'active-num' : 'num']
    }, [_vm._v(_vm._s(_vm.getLikesCount(item.likes + '')))]), _vm._v(" "), _c('i', {
      class: [item.isLike ? 'active-good' : 'good']
    })])]), _vm._v(" "), _c('section', [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })]), _vm._v(" "), (item.parent) ? _c('div', {
      staticClass: "origin"
    }, [_c('div', {
      staticClass: "origin-name"
    }, [_vm._v(_vm._s(item.parent.username))]), _vm._v(" "), _c('div', {
      staticClass: "origin-time"
    }, [_vm._v(_vm._s(_vm.getTime(item.parent.date)))]), _vm._v(" "), _c('div', {
      staticClass: "origin-content"
    }, [_vm._v("\n                    " + _vm._s(item.parent.content) + "\n                ")])]) : _vm._e()])
  }), 0), _vm._v(" "), (!_vm.isSharePage && _vm.comments.length >= 5) ? _c('div', {
    staticClass: "check-all",
    on: {
      "click": function($event) {
        return _vm.appPostMessage('checkAllComment')
      }
    }
  }, [_vm._v("查看全部评论 "), _c('i')]) : (!_vm.isSharePage && _vm.comments.length > 0 && _vm.comments.length < 5) ? _c('div', {
    staticClass: "show-all"
  }, [_vm._v("已显示全部内容")]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62c31b58!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-government.vue
// module id = 856
// module chunks = 2